import React, {
  useReducer,
  createContext,
  useContext,
  useEffect,
  Fragment,
} from 'react';
import { useParams } from 'react-router-dom';
import TwoCards from '../../../../../../components/Card/TwoCards';
import CustomerMainCard from './CustomerMainCard';
import CustomerFromCard from './CustomerFormCard';
import { reducer, initialState } from './reducer';
import Chip from '@material-ui/core/Chip';
import green from '@material-ui/core/colors/green';
import blueGray from '@material-ui/core/colors/blueGrey';
import { store as mainStore } from '../../../../../../store';
import { fetchingTransactions } from './actions';
import useTitle from 'hooks/useTitle';
import { useQueries } from 'react-query';

export const store = createContext(null);
const { Provider } = store;

const Customer = () => {
  var { id } = useParams();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { state: mainState, showMessage, showError } = useContext(mainStore);
  const { itemsCountPerPage } = mainState.Props;
  const { customer } = state;

  const {
    fetchingUserData,
    fetchingOrders,
    fetchingNotes,
    fetchingSms,
    fetchingMessages,
    fetchingPhones,
  } = state;

  const fetchingCustomerData = async () => {
    const userData = await fetchingUserData(id);
    dispatch({
      type: 'LOAD',
      payload: { name: 'customer', value: userData },
    });
  };

  const fetchingCustomerPhones = async () => {
    const phones = await fetchingPhones(id);
    dispatch({
      type: 'LOAD',
      payload: { name: 'phones', value: phones },
    });
  };
  const fetchingCustomerNotes = async () => {
    const notes = await fetchingNotes(id);
    dispatch({ type: 'LOAD', payload: { name: 'notes', value: notes } });
  };
  const fetchingCustomerOrders = async () => {
    const orders = await fetchingOrders(id, 1, itemsCountPerPage);
    dispatch({ type: 'LOAD', payload: { name: 'orders', value: orders } });
  };
  const fetchingCustomerTransactions = async () => {
    const transactions = await fetchingTransactions(id, 1, itemsCountPerPage);
    dispatch({
      type: 'LOAD',
      payload: { name: 'transactions', value: transactions },
    });
  };
  const fetchingCustomerSms = async () => {
    const allSms = await fetchingSms(id, 1, itemsCountPerPage);
    dispatch({ type: 'LOAD', payload: { name: 'allSms', value: allSms } });
  };
  const fetchingCustomerMessages = async () => {
    const messages = await fetchingMessages(id, 1, itemsCountPerPage);
    dispatch({
      type: 'LOAD',
      payload: { name: 'messages', value: messages },
    });
  };

  const fetchingAllDatas = (whatToRefresh) => {
    if (whatToRefresh) {
      if (whatToRefresh === 'fetchingCustomerPhones') fetchingCustomerPhones();
    }
    fetchingCustomerData();
    fetchingCustomerPhones();
    fetchingCustomerNotes();
    fetchingCustomerOrders();
    fetchingCustomerTransactions();
    // fetchingCustomerSms();
    // fetchingCustomerMessages();
  };

  useEffect(() => {
    fetchingAllDatas();
  }, []);
  useTitle(`${customer?.company}`);

  return (
    <Provider
      value={{
        state,
        dispatch,
        refresh: fetchingAllDatas,
        showMessage,
        showError,
      }}
    >
      <TwoCards
        title={
          <Fragment>
            {customer
              ? customer.legal
                ? `${
                    customer.company
                      ? customer.company
                      : 'نام شرکت هنوز وارد نشده است'
                  }`
                : `${customer.firstName} ${customer.lastName}`
              : null}
            <Chip
              variant="outlined"
              color="secondary"
              size="small"
              label={customer && customer.online ? `آنلاین` : `آفلاین`}
              style={{
                marginRight: 5,
                color: customer && customer.online ? green[500] : blueGray[500],
                borderColor:
                  customer && customer.online ? green[500] : blueGray[500],
              }}
            />
          </Fragment>
        }
        secondaryContent={<CustomerFromCard />}
      >
        <CustomerMainCard />
      </TwoCards>
    </Provider>
  );
};

export default Customer;
